import { Component } from '@angular/core';
import { ImageUrlService } from '@nx-ng/services/image-url.service';

@Component({
  selector: 'nx-ng-m-ticket-info-modal',
  templateUrl: './m-ticket-info-modal.component.html',
})
export class MTicketInfoModalComponent {
  constructor(public imageUrlService: ImageUrlService) {}
}
